import { CustomColumn } from '../../../types/customColumn';

export const excludedSubjectProductColumns: CustomColumn<any>[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'id',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return <div>{pageIndex * pageSize + index + 1}</div>;
    },
  },

  {
    Header: 'Producto / Servicio',
    accessor: 'productName',
    customCell: ({ row }) => {
      const { productCode, productName, categoryName, type } = row.original;

      return (
        <div className="text-sm leading-6">
          {/* Código siempre visible */}
          <div className="text-sm font-semibold text-black dark:text-white">
            ({productCode || '—'})
          </div>

          {/* Nombre */}
          <div className="text-gray-800 dark:text-gray-200 text-sm">
            {productName || '—'}
          </div>

          {/* Categoría → Siempre en una nueva línea */}
          {type === 'PRODUCT' && (
            <div className="text-gray-500 dark:text-gray-400 mt-1 text-xs">
              <div className="font-semibold">Categoría:</div>
              <div className="text-gray-600 dark:text-gray-300">
                {categoryName || '—'}
              </div>
            </div>
          )}

          {/* Etiqueta para servicios → también debajo */}
          {type === 'SERVICE' && (
            <div className="text-gray-500 dark:text-gray-400 mt-1 text-xs">
              (SERVICIO)
            </div>
          )}
        </div>
      );
    },
  },

  {
    Header: 'Costo Unitario',
    accessor: 'unitCost',
    customCell: ({ value }) => <div>$ {Number(value || 0).toFixed(2)}</div>,
  },

  {
    Header: 'Cantidad',
    accessor: 'quantity',
    customCell: ({ row }) => {
      const { quantity, unitCode, type, settledQuantity } = row.original;

      return (
        <div className="text-sm leading-6">
          <div>
            {Number(quantity || 0).toFixed(2)}{' '}
            {type === 'PRODUCT' ? unitCode : ''}
          </div>

          {type === 'PRODUCT' && settledQuantity !== undefined && (
            <div className="text-gray-500 mt-1 text-xs">
              <strong>Asentado:</strong> {Number(settledQuantity).toFixed(2)}{' '}
              {unitCode || ''}
            </div>
          )}
        </div>
      );
    },
  },

  {
    Header: 'Retención de Renta',
    accessor: 'incomeTaxWithholding',
    customCell: ({ value }) => <div>$ {Number(value || 0).toFixed(2)}</div>,
  },

  {
    Header: 'Costo Total',
    accessor: 'totalAmount',
    customCell: ({ value }) => <div>$ {Number(value || 0).toFixed(2)}</div>,
  },
];
